import DesignEmailView from './DesignEmailView';

export default DesignEmailView;
